
import { BaseApiClient } from "../baseApiClient";
import { fetchAllStaff, fetchStaffById } from "./operations/fetchStaff";
import { terminateStaff } from "./operations/terminateStaff";
import { staffMapper } from "./mappers";

/**
 * API client for AI staff-related operations
 */
export const staffApiClient = {
  // Core operations
  fetchAllStaff,
  fetchStaffById,
  terminateStaff,
  
  // For backward compatibility
  mapToAIStaffMember: staffMapper.toFrontend,
  
  // Cache management
  clearCache: () => {
    BaseApiClient.clearCache('staff:');
  }
};
